export function areAllFieldsDefined<T>(obj: T, fields: Array<keyof T>): boolean {
    return fields.every((field) => obj?.[field] != null); // checks both null and undefined
}
